import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-abedb246"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "kpi-card"
};
const _hoisted_2 = {
  class: "kpi-header"
};
const _hoisted_3 = {
  class: "label"
};
const _hoisted_4 = {
  class: "kpi-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loading_element = _resolveComponent("loading-element");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($props.type), 1), _createVNode(_component_loading_element, {
    loading: $props.loading,
    size: 60
  }, {
    default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent($props.component), {
      class: "value",
      value: $props.value,
      tight: ""
    }, null, 8, ["value"]))]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])]);
}